import {Injectable} from "@angular/core";
import {BehaviorSubject, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AppEventsService {
  public scheduleReserved = new Subject<void>();
  public creditsUpdate = new Subject<any>();
  private _credits: { [lang: string]: BehaviorSubject<number> } = {};

  constructor() { }

  public credits(lang: string): BehaviorSubject<number> {
    let result = this._credits[lang];
    if (!result) {
      result = new BehaviorSubject<number>(0);
      this._credits[lang] = result;
    }
    return result;
  }
}
